import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteTev2MonthlySongMutationVariables = Types.Exact<{
  seq: Types.Scalars['Int']['input'];
}>;


export type DeleteTev2MonthlySongMutation = { __typename?: 'Mutation', delteTev2MonthlySong: { __typename?: 'Payload', count: number, error?: Types.Error | null } };


export const DeleteTev2MonthlySongDocument = gql`
    mutation DeleteTev2MonthlySong($seq: Int!) {
  delteTev2MonthlySong(seq: $seq) {
    count
    error
  }
}
    `;
export type DeleteTev2MonthlySongMutationFn = Apollo.MutationFunction<DeleteTev2MonthlySongMutation, DeleteTev2MonthlySongMutationVariables>;

/**
 * __useDeleteTev2MonthlySongMutation__
 *
 * To run a mutation, you first call `useDeleteTev2MonthlySongMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTev2MonthlySongMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTev2MonthlySongMutation, { data, loading, error }] = useDeleteTev2MonthlySongMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *   },
 * });
 */
export function useDeleteTev2MonthlySongMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTev2MonthlySongMutation, DeleteTev2MonthlySongMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTev2MonthlySongMutation, DeleteTev2MonthlySongMutationVariables>(DeleteTev2MonthlySongDocument, options);
      }
export type DeleteTev2MonthlySongMutationHookResult = ReturnType<typeof useDeleteTev2MonthlySongMutation>;
export type DeleteTev2MonthlySongMutationResult = Apollo.MutationResult<DeleteTev2MonthlySongMutation>;
export type DeleteTev2MonthlySongMutationOptions = Apollo.BaseMutationOptions<DeleteTev2MonthlySongMutation, DeleteTev2MonthlySongMutationVariables>;